/**
 * クライアントサイド gzip 圧縮 (2 フェーズ取込の presigned PUT 用)。
 *
 * ブラウザネイティブの `CompressionStream('gzip')` を使う (依存追加なし)。
 * CompressionStream 非対応ブラウザ (Safari 16.3 以下 / Firefox 112 以下など) では圧縮せず
 * 元の Blob をそのまま返す。圧縮したか否かは `compressed` で呼び出し側に返し、
 * presigned URL 発行時にサーバへ伝えてキー拡張子 (.csv.gz / .csv) を決めてもらう。
 * TS 4.9 の lib.dom に CompressionStream 型が無いためローカル宣言する。
 */

interface CompressionStreamLike {
  readonly readable: ReadableStream<Uint8Array>;
  readonly writable: WritableStream<Uint8Array>;
}
type CompressionStreamCtor = new (format: "gzip" | "deflate") => CompressionStreamLike;

/** ブラウザが CompressionStream を持つか。 */
export function isGzipSupported(): boolean {
  return typeof (globalThis as any).CompressionStream === "function";
}

/**
 * File/Blob を gzip 圧縮した Blob を返す (streaming・大きい CSV でも全量メモリ化しない)。
 * 非対応ブラウザでは圧縮せず入力をそのまま返す (compressed: false)。
 */
export async function gzipBlob(
  input: Blob
): Promise<{ blob: Blob; compressed: boolean }> {
  const Ctor = (globalThis as any).CompressionStream as CompressionStreamCtor | undefined;
  if (typeof Ctor !== "function") {
    return { blob: input, compressed: false };
  }
  const compressed = (input.stream() as any).pipeThrough(new Ctor("gzip"));
  return { blob: await new Response(compressed as any).blob(), compressed: true };
}
